export const FOLDER_TYPES = {
  documents: '1.6.',
  ownhouse: '1.6.1',
  safety: '1.6.2',
  communication: '1.6.3',
  appliances: '1.6.4',
  hvac: '1.6.5',
  service: '1.6.6',
}
